import React from 'react';
// import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

const DeveloperArea = () => (
  <>
    Developer Area
  </>
);

DeveloperArea.propTypes = {
};

export const query = graphql`
  fragment DeveloperAreaBlockFragment on ContentfulDeveloperArea {
    __typename
    personalizations {
      ...PersonalizationFragment
    }
  }
`;

export default DeveloperArea;
